import apiClient from '../api';

/**
 * Valida um identificador no controle de inscrição
 * @param {string} identifier - O identificador a validar (INEP, CNPJ, etc.)
 * @returns {Promise<object>} - { data: { id, identifier, name, data, control_name }, used }
 */
export async function validateRegistrationControl(identifier) {
    try {
        const response = await apiClient.post('/validate-registration-control', { identifier });
        return response.data;
    } catch (err) {
        const msg = err.response?.data?.message || 'Erro ao validar identificador.';
        throw { cod: 'RC_VALIDATE_FAIL', errMsg: msg };
    }
}

/**
 * Busca a configuração pública do controle de inscrição
 * @returns {Promise<object|null>} - { enabled, identifier_label, identifier_field, name } ou null
 */
export async function getRegistrationControlConfig() {
    try {
        const response = await apiClient.get('/registration-control-config');
        return response.data?.data || null;
    } catch {
        return null;
    }
}
